<template>
    <div class="common_container">
        <el-form :model="ruleForm" :rules='rules' ref='ruleForm' label-width="80px">
            <!-- 协议名称 相应时长 -->
            <el-row>
                <el-col :span="12" >
                    <el-form-item label="协议名称" prop='title'>
                        <el-input v-model="ruleForm.title" class="form-input" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12" >
                    <el-form-item label="响应时长">
                        <el-input v-model="ruleForm.responseTime" class="form-input" type='number' nim='0' /> 分钟
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 客户合同 完成时长 -->
            <el-row>
                <el-col :span="12">
                    <el-form-item label="客户合同" prop='contract'>
                        <el-select class="form-input"
                            :loading="loading"
                            :remote-method="remoteMethodContract"
                            clearable
                            filterable
                            placeholder="请输入..."
                            remote
                            v-model="ruleForm.contract">
                            <el-option :key="item.serialNumber" :label="item.title" :value="item.serialNumber" v-for="item in contractData"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12" >
                    <el-form-item label="完成时长">
                        <el-input v-model="ruleForm.completionTime" class="form-input" type='number' nim='0' /> 分钟
                    </el-form-item>
                </el-col>
            </el-row>
            <!-- 服务方 协议说明 -->
            <el-row>
                <el-col :span="12">
                    <el-form-item label="服务方" prop='servers'>
                        <el-select v-model="ruleForm.servers" clearable class="form-input" placeholder="请选择">
                            <el-option
                             v-for="item in serverData"
                             :key="item.id"
                             :label="item.name"
                             :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12" >
                    <el-form-item label="协议说明">
                        <el-input type='textarea' v-model="ruleForm.description" autosize class="form-input"/>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <el-form-item>
                        <el-button type="primary" size="small" @click="submitForm('ruleForm')" :disabled="isSubmit">{{ type == 'edit' ? '修改' : '创建' }}</el-button>
                        <el-button type="default" size="small" @click="resetForm('ruleForm')">重置</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
import { celevelRules } from '../serve.rules'
import services from '../serve.services'
const rules = celevelRules()
export default {

    props:{
        type:{
            type:String,
            default:"add"
        },
        form: Object,
        callback: Function
    },

    data() {
        return {
            ruleForm: {
                title: '',
                contract:''
            },
            loading: true,
            rules,
            serverData: [],
            contractData: [],
            isSubmit:false
        }
    },

    created() {
        if(this.type == 'edit'){
            this.$modal.title = "修改服务";
            this.ruleForm = {
                ...this.form,
                contract: this.form.contract.serialNumber,
                servers: this.form.server.name
            }
            this.contractData = [{
                    serialNumber:this.form.contract.serialNumber,
                    title:this.form.contract.title
            }]
        }
    },

    mounted() {
        services.treeChildren({ type: 'group', departmentId: '99999' })
            .then(res => this.serverData = res.list)
            .catch(err => this.$message.error(err.message))
    },

    methods: {
     // 搜索用户
        remoteMethodContract(query) {
            if(query !== "") {
                this.loading = true;
                services.contractSearch({keyword:query})
                .then(res => this.contractData = res.list)
                .catch(err => this.$message.error(err.message))
                .finally(() => this.loading = false);
            } else {
                this.contractData = [];
            }
        },
        // 确认提交按钮
        submitForm(formName) {
            this.isSubmit=true
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let params = {
                        completionTime: this.ruleForm.completionTime,
                        contract: this.ruleForm.contract,
                        description: this.ruleForm.description,
                        responseTime: this.ruleForm.responseTime,
                        serialNumber: this.ruleForm.serialNumber,
                        title: this.ruleForm.title,
                        updateTime: this.ruleForm.updateTime,
                        server: `${this.ruleForm.servers}` || `${this.form.server.id}`
                    }
                    switch (this.type) {
                        case 'add':
                            this.request({ request: services.serviceSlaAdd, params })
                            break;
                        case 'edit':
                            this.request({ request: services.serviceSlaEdit, params })
                            break;
                    }
                } else {
                    this.isSubmit=false
                    this.$message.error('✳为必填项，请全部填写')
                }
            });
        },

        // 重置
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },

        // 发起请求
        request({ request, params }) {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            request(params).then( res => {
                this.$message.success(`${this.type === 'edit' ? '编辑' : '创建'}成功`)
            }).catch(err => {
                this.isSubmit=false
                this.$message.error(err.message)
            }).finally(() => {
                loading.close()
                this.$modal.close()
                this.callback()
            })
        }
    }
    }
</script>

<style lang="scss" scoped>
    .el-form-item {
        img {
            vertical-align: middle;
            margin-left: 5px;
        }
    }
</style>
